//信用积分模块相关
import { fetchGet, fetchPost } from "../libs/reqCommon";
import { getUrlParam, linktoplatform, handleProductUrl } from "@/libs";

const state = {
    lastYearScore: '',//上年度信用积分
    shopName: '',//店铺名字
    editpenaltyVal: '',//编辑的处理结果
    ifMyInformer: false,//false->不是我的举报记录
    deductMarks: [],
    shopList: [],
    creditSearchData: {},//搜索的参数
    linkVerifyResult: [{}],
    productIdprice: {},
    tbpassword: '',//淘口令解析后的链接
    showChangeInfo: false,//是否展示修改信息
    //授权处理结果说明
    InstallList: [
        '举报材料与对应店铺不符合，本次视为无效（恶意）举报',
        '在规定时间内整改合格',
        '申诉内容合理，本链接不存在违规情况',
        '存在标价违规或到手价违规',
        '存在店铺、平台优惠券或活动违规',
        '存在副标题、广告语、主图违规或咨询客服违规',
        '存在买几送几、买几打几折违规',
        '其他'],
    //非授权处理结果说明
    unauthorizativeType: [
        '通知店铺整改',
        '知识产权投诉'
    ],
    creditShopid: {},//店铺id，店铺shoptype
    creditFlowList: [],//信用积分和授权违规流程
    violateSetInfo: {},
    typeList: [//积分周期1自然月2自然季度3自然半年4自然年
        {
            title: '自然月',
            info: '每个自然月份为一个积分周期。',
            type: 1
        },
        {
            title: '自然季度',
            info: '自然月01-03月，04-06月，07-09月，10-12月分别为一个积分周期。',
            type: 2
        },
        {
            title: '自然半年',
            info: '自然年的01月01日至06月30日为一个积分周期，07月01日至12月31日为下一个积分周期。',
            type: 3
        },
        {
            title: '自然整年',
            info: '自然年的01月01日至12月31日为一个周期。',
            type: 4
        }, {
            title: '自定义整年',
            info: '',
            custom: 1,
            type: 4
        }, {
            title: '自定义半年',
            info: '',
            custom: 1,
            type: 3
        },
        {
            title: '自定义季度',
            info: '自然月09/10/11，12/01/02，03/04/05,06/07/08分别为一个积分周期',
            custom: 1,
            type: 2
        }
    ],
    dimShopName: [],
    dateCycle: {//积分周期时间范围
        integralCycel: [],
        shopCycel: ''
    },
    normaltableLoading: true,//表格加载动画(举报信息审核)
    infoProductPrice: false,//是否选择了产品 true是
    autoReviewDisable: false,//自动复查 ture 按钮禁止
    autoCountTimeWord: '',//自动复查的文案
}
const getters = {
    lastYearScore: state => {
        return state.lastYearScore;
    },
    shopName: state => {
        return state.shopName;
    },
    editpenaltyVal: state => {
        return state.editpenaltyVal
    },
    ifMyInformer: state => {
        return state.ifMyInformer
    },
    getShopList: state => {
        return state.shopList
    },
}
const mutations = {
    getLastYear(state, payLoad) {
        state.lastYearScore = payLoad
    },
    getshopName(state, payLoad) {
        state.shopName = payLoad
    },
    getEditpenaltyVal(state, payLoad) {
        state.editpenaltyVal = payLoad
    },
    getIfMyInformer(state, payLoad) {
        state.ifMyInformer = payLoad
    },
    saveCheckId(state, payLoad) {
        state.deductMarks = payLoad
    },
    shopList(state, payLoad) {
        state.shopList = payLoad
    },
    commonHeaderSearch(state, payLoad) {
        state.creditSearchData = payLoad
    },
    getVerifyResult(state, payLoad) {
        state.linkVerifyResult = payLoad
    },
    getTbPassword(state, payLoad) {
        state.tbpassword = payLoad
    },
    infoProductIdChange(state, data) {
        console.log(data)
        if (data) {
            let result = state.linkVerifyResult
            let payLoad = data.data[0]
            result[0].checkprice = payLoad.addprice
            result[0].availablecheckprice = payLoad.handprice
            state.linkVerifyResult = result
            state.infoProductPrice = true
            state.productIdprice = data
        }
    },
    changeCompleteShow(state) {
        state.showChangeInfo = !state.showChangeInfo
    },
    saveCreditChangeShopId(state, payLoad) {
        state.creditShopid = payLoad
    },
    creditRelatedFlow(state, payLoad) {
        state.creditFlowList = payLoad
    },
    violateSet(state, payLoad) {
        payLoad.repleader = payLoad.repleader == 1 ? true : false//是否二次申诉 1是 0否
        state.violateSetInfo = payLoad
    },
    getDimShopName(state, payLoad) {
        state.dimShopName = payLoad
    },
    saveDateCycle(state, payLoad) {
        state.dateCycle = {
            integralCycel: payLoad
        }

    },
    changenormaltableLoading(state, payLoad) {
        state.normaltableLoading = payLoad
    },
    saveAutoReviewDisable(state, payLoad) {
        state.autoReviewDisable = payLoad
    },
    saveAutoCountTime(state, payLoad) {
        state.autoCountTimeWord = payLoad
    }
}
const actions = {
    getLastYearScore({ commit }, query) {
        fetchGet("/hcm/hcmShop/getLastYearScore", query).then(res => {
            commit('getLastYear', res.data.shopscore)
        });
    },
    GetListBMC({ commit }) {
        //店铺下拉
        return new Promise((r, j) => {
            fetch({
                url: "hcm/hcmShop/GetListBMC",
                method: "get"
            }).then(res => {
                if (res.status == "10000") {
                    this.shopList = res.data;
                    commit('shopList', res.data)
                    r(res.data)
                }
            });
        })
    },
    getVerifyReportLink({ commit }, query) {
        //违规举报验证链接
        let url
        let type
        if (query.indexOf('+first') != -1) {
            url = [query.split('+first')[0]]
            type = 0
        } else if (query.indexOf('+second') != -1) {
            url = query.split('+second')[0].split(",")
            type = 1
        } else {
            url = query
            type = ''
        }
        let link = [];
        let skuId = [];
        url.map(item => {
            let shortUrl = handleProductUrl(item)
            link.push(shortUrl);
            if (/&sku/.test(item) || /skuid/.test(item)) {
                skuId.push(getUrlParam(item, "skuId") || getUrlParam(item, "skuid"));
            }
        });
        let data = {
            link: String(link),
            platform: linktoplatform(url[0]),
            skuid: String(skuId)
        };
        if (type == 0) {
            data.type = 0
        } else if (type == 1) {
            data.type = 1
        }
        return new Promise((r, j) => {
            fetchGet("/hcm/hcmReport/verifyReportLink", data).then((res) => {
                if (res.status === '10000') {
                    let result = []
                    res.data.map(item => {
                        result.push(JSON.parse(item))
                    })
                    let params = []
                    result.forEach(item => {
                        let obj = Object.assign({});
                        let skuproduct = item.skuproduct ? JSON.parse(item.skuproduct) : null
                        if (skuproduct) {
                            var { productid, skuavailablecheckprice, skucheckprice, availableprice, skuprice, skuname, productname } = skuproduct
                        }
                        if (item.product_id || productid) obj.productinfoid = skuproduct ? productid : item.product_id
                        if (item.productname || productname) obj.productinfo = skuproduct ? productname : item.productname
                        if (item.shopname) obj.shopname = item.shopname
                        if (item.shopid) obj.shopid = item.shopid
                        if (item.skuname || skuname) obj.skuinfo = skuproduct ? skuname : item.skuname
                        if (item.itemtitle) obj.itemtitle = item.itemtitle
                        if (item.platform) obj.platformCode = item.platform
                        if (item.availablecheckprice || skuavailablecheckprice) obj.availablecheckprice = skuproduct ? skuavailablecheckprice : item.availablecheckprice
                        if (item.checkprice || skucheckprice) obj.checkprice = skuproduct ? skucheckprice : item.checkprice

                        if (item.availableprice || availableprice) obj.availableprice = skuproduct ? availableprice : item.availableprice
                        if (item.availablecheckprice || item.availablecheckprice == 0) obj.availablecheckprice = item.availablecheckprice

                        if (item.price || skuprice) obj.price = skuproduct ? skuprice : item.price
                        if (item.wangwang) obj.wangwang = item.wangwang
                        if (item.itemid) obj.itemid = item.itemid
                        if (item.shoptype) obj.shoptype = item.shoptype

                        obj.productClassifyId = item.product_classify_id
                        obj.itemlink = item.itemlink
                        obj.reason = item.reason
                        params.push(obj)
                    })
                    commit('getVerifyResult', params)
                    console.log(params)
                    console.log('举报验证链接返回的接口数据')

                    r()
                }
                j()
            }).catch(() => {
                j();
            })
        })

    },
    getTBPassword({ commit }, query) {
        //淘口令
        let params = {
            vekey: "V00003012Y03561196",
            para: query,
            parsetkl: "1",
        }
        return new Promise((r, j) => {
            fetchGet("taobao", params).then(res => {
                commit('getTbPassword', res)
                r()
            })
        })
    },
    getInfoByProductIds({ commit }, query) {
        return new Promise((r, j) => {
            fetchGet("/hcm/hcmProduct/getInfoByProductIds", query).then(res => {
                commit('infoProductIdChange', res)
                r(res)
            })
        })
    },
    getCreditFlowList({ commit }, query) {
        //信用积分流程
        return new Promise((r, j) => {
            fetchGet("hcm/hcmApproval/getHcmApprovalByRelated", { related: query }).then(res => {
                if (res.status == '10000') {
                    commit('creditRelatedFlow', res)
                    r(res)
                }
                j()

            }).catch(() => {
                j()
            })
        })
    },
    selectViolationSetting({ commit }) {
        fetchPost('/hcm/cus/selectViolationSetting').then(res => {
            if (res.status == '10000') {
                commit('violateSet', res.data)
            }
        })
    },
    async getfinShopByName({ commit }, query) {
        //店铺名称模糊搜索
        await fetchGet("/hcm/hcmShop/findShopByName", query).then(res => {
            if (res.status == '10000') {
                let result = []
                res.data.map(item => {
                    item.value = item.shopName;
                    if (query.platformCode) {
                        if (item.platformCode === query.platformCode) {
                            result.push(item)
                        }
                    } else {
                        result.push(item)
                    }

                });
                commit('getDimShopName', result)
            }
        })
    },
    async getDateCycle({ commit }) {
        let res = await fetchGet("/hcm/hcmReport/getPointsCycle")
        //type:1自然月2自然季度3自然半年4自然年
        if (res.status !== '10000') {
            return false
        }
        commit('saveDateCycle', res.data)
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}
